import { useState, useCallback, useRef, useEffect } from 'react';

export const useShortcutCooldown = (options = {}) => {
  const { cooldownMs = 3000 } = options;
  const [isLoading, setIsLoading] = useState(false);
  const timeoutRef = useRef(null);

  const execute = useCallback(
    async (fn) => {
      if (isLoading) return;
      setIsLoading(true);
      try {
        await fn();
      } finally {
        timeoutRef.current = setTimeout(() => {
          setIsLoading(false);
          timeoutRef.current = null;
        }, cooldownMs);
      }
    },
    [isLoading, cooldownMs]
  );

  useEffect(() => () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  return { isLoading, execute };
};
